/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_ImprintInputs */

const de_commons_footer_imprint = /** @type {(inputs: Commons_Footer_ImprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

/** @type {(inputs: Commons_Footer_ImprintInputs) => LocalizedString} */
const en_commons_footer_imprint = de_commons_footer_imprint;

/**

* @param {Commons_Footer_ImprintInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_imprint = /** @type {((inputs?: Commons_Footer_ImprintInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_ImprintInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_imprint(inputs)
	return en_commons_footer_imprint(inputs)
});